export default __webpack_public_path__ + "navigation-examples-basic-v1-960-4cb4e7abfb4d2645a2c34c6633ba47ab.png";